import { useEffect, useLayoutEffect, useRef } from "react";

function useIrregularInterval(callback, delays) {
    const delayIndex = useRef(0);
    const savedCallback = useRef(callback);
    const savedDelays = useRef(delays);

    // Remember the latest callback if it changes.
    useLayoutEffect(() => {
        savedCallback.current = callback;
        savedDelays.current = delays;
    }, [callback, delays]);

    // Set up the interval.
    useEffect(() => {
        const delay = savedDelays.current[delayIndex.current];
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }

        let timeoutId;
        let onTimeout;
        onTimeout = () => {
            // call the callback
            savedCallback.current(delayIndex.current);

            // get next delay 
            delayIndex.current =
                (delayIndex.current + 1) % savedDelays.current.length;

            // schedule timeout
            timeoutId = setTimeout(
                onTimeout,
                savedDelays.current[delayIndex.current]
            );
        };
        timeoutId = setTimeout(
            onTimeout,
            savedDelays.current[delayIndex.current]
        );
        return () => {
            clearTimeout(timeoutId);
        };
    }, [savedDelays, savedCallback]);
}

export default useIrregularInterval;
